export default "__VITE_ASSET__f5652884__"